import moment from "moment";
import _ from "lodash";

export class CorbeilleElement {
    id?: number;
    type?: string | null;
    type_libelle?: string;
    element_id?: number;
    libelle?: string;
    raison?: string | null;
    supprime_par_id?: number | null;
    supprime_par_nom?: string | null;
    supprime_le?: string;
    purge_prevue_le?: string | null;
    // Renseigné par le détail seulement (vide dans la liste)
    apercu: Array<CorbeilleElement.LigneApercu> = [];

    constructor(data: any) {
        _.assign(this, data);
    }

    get supprime_le_str(): string {
        return this.supprime_le
            ? moment(this.supprime_le, "YYYY-MM-DD HH:mm:ss").format(
                  "DD/MM/YYYY HH:mm"
              )
            : "";
    }

    get purge_prevue_le_str(): string {
        return this.purge_prevue_le
            ? moment(this.purge_prevue_le, "YYYY-MM-DD").format("DD/MM/YYYY")
            : "";
    }
}

export namespace CorbeilleElement {
    export interface LigneApercu {
        libelle: string;
        valeur: string;
    }
}
